// Status page tones (screens/Status.tsx, the nav rail's dot): one tone per source state.
import type { SourceState } from '@req/contracts';

export type Tone = 'ok' | 'idle' | 'warn' | 'crit';
export const TONE: Record<SourceState, Tone> = { ok: 'ok', waiting: 'idle', stale: 'warn', degraded: 'warn', never: 'crit', failed: 'crit' };
export const DOT: Record<Tone, string> = { ok: 'bg-ok', idle: 'bg-faint', warn: 'bg-warn', crit: 'bg-crit' };
export const PILL: Record<Tone, string> = { ok: 'bg-ok-bg text-ok', idle: 'bg-line-2 text-body', warn: 'bg-warn-bg text-warn', crit: 'bg-crit-bg text-crit' };
